<template>
  <div class="container mt-5">
    <div class="row mb-5">
      <div class="col-8">
        <h3>Create fixture</h3>
      </div>
      <div class="col-4 text-right">
        <button @click="$router.go(-1)" type="button" class="btn btn-secondary">Back</button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <form @submit="submit">
          <div class="form-group">
            <label for="name">Fixture Name *</label>
            <input type="text" name="name" id="name" class="form-control form-control-lg" placeholder="ex: Team A - Team B" required v-model="form.name">
          </div>
          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <label for="date_start">Date Start *</label>
                <date-picker v-model="form.date_start" :config="options" required class="form-control-lg"></date-picker>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label for="event">Parent Event *</label>
                <v-select v-model="form.event" :options="events" required></v-select>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label for="event">Venue</label>
                <v-select v-model="form.venue" :options="venues"></v-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <label for="home-team">Home Team *</label>
              <v-select v-model="form.homeTeam" :options="teams" required></v-select>
            </div>
            <div class="col-6">
              <label for="home-team">Away Team *</label>
              <v-select v-model="form.awayTeam" :options="teams" required></v-select>
            </div>
          </div>
          <hr class="mt-5 mb-5">
          <button type="submit" class="btn btn-primary btn-lg">Create</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import { eventService } from '../../services/event'
import { teamService } from '../../services/team'
import { venueService } from '../../services/venue'
import vSelect from 'vue-select'
import moment from 'moment'
import clone from 'clone'
import { fixtureService } from '../../services/fixture'

export default {
  name: 'FixtureAdd',
  components: { datePicker, vSelect },
  data () {
    return {
      date: new Date(),
      options: {
        format: 'YY-MM-DD HH:mm',
        useCurrent: false
      },
      teams: [],
      events: [],
      venues: [],
      form: {
        name: '', date_start: '', event: null, homeTeam: null, awayTeam: null, venue: null
      },
      selected: null
    }
  },
  mounted () {
    teamService.getAll().then(result => {
      for (let team of result.data.teams) {
        this.teams.push({label: team.name, value: team._id})
      }
    })
    venueService.getAll().then(result => {
      for (let venue of result.data.venues) {
        this.venues.push({label: venue.name, value: venue._id})
      }
    })
    eventService.getAll().then(result => {
      for (let event of result.data.events) {
        this.events.push({label: event.name, value: event._id})
      }
      if (this.$route.params.eventid) {
        let foundEvent = result.data.events.filter(ev => ev._id === this.$route.params.eventid)[0]
        if (foundEvent) {
          this.form.event = { label: foundEvent.name, value: foundEvent._id }
        }
      }
    })
  },
  methods: {
    submit (ev) {
      ev.preventDefault()
      let clonedFixture = clone(this.form)
      clonedFixture.date_start = moment(clonedFixture.date_start, 'YY-MM-DD HH:mm').valueOf()

      fixtureService.insertOne({
        name: clonedFixture.name,
        venue: clonedFixture.venue ? clonedFixture.venue.value : undefined,
        date_start: clonedFixture.date_start,
        event: clonedFixture.event.value
      }).then(fixtureRes => {
        fixtureService.linkFixtureAndTeams(fixtureRes._id, clonedFixture.homeTeam.value, clonedFixture.awayTeam.value).then(linkRes => {
          this.$router.push({ name: 'Event', params: { id: clonedFixture.event.value } })
        })
      })
    }
  }
}
</script>
<style lang="scss">
div.dropdown-toggle::after{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/Fixtures/FixtureAdd.vue